import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MntUsersRoutingModule } from "./mnt-users-routing.module";
import { SettingsComponent } from "./settings/settings.component";
import { ProfileComponent } from "./profile/profile.component";
import { MntMasterModule } from "../mnt-master/mnt-master.module";
import { AppMaterialModule } from "../app-material/app-material.module";
import {
  MatInputModule,
  MatTableModule,
  MatToolbarModule
} from "@angular/material";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { FlashMessagesModule } from "angular2-flash-messages";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { SharedModule } from "../shared/shared.module";
import { StaffComponent } from './staff/staff.component';
import { StaffFormComponent } from './staff-form/staff-form.component';
// import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { StaffEditComponent } from './staff-edit/staff-edit.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientEditComponent } from './client-edit/client-edit.component';
import { PrinterComissionsComponent } from './printer-comissions/printer-comissions.component';
import { DesignerCommissionsComponent } from './designer-commissions/designer-commissions.component';
import { ViewClientComponent } from './view-client/view-client.component';
import { ClientAddressEditComponent } from './client-address-edit/client-address-edit.component';
import { ClientDiscountPercenatageComponent } from './client-discount-percenatage/client-discount-percenatage.component';
import { StaffComissionPayComponent } from './staff-comission-pay/staff-comission-pay.component';
import { ClientAddressListComponent } from './client-address-list/client-address-list.component';
import { ClientAddressFormComponent } from './client-address-form/client-address-form.component';
import { MntInvoicesModule } from "../mnt-invoices/mnt-invoices.module";
import { ArtworkfilesComponent } from './artworkfiles/artworkfiles.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ManageSubscriptionComponent } from './manage-subscription/manage-subscription.component';
import { UpdateCardComponent } from './update-card/update-card.component';
import { ClientImportComponent } from './client-import/client-import.component';

export const options: Partial<IConfig> = {
};


@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    CommonModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    ReactiveFormsModule,
    FormsModule,
    MntUsersRoutingModule,
    FlashMessagesModule,
    MntMasterModule,
    SharedModule,
    MntInvoicesModule,
    NgxMaskModule.forRoot(options)

  ],
  exports: [CommonModule, MatToolbarModule, MatInputModule, MatTableModule],
  declarations: [SettingsComponent, ProfileComponent, ResetPasswordComponent, StaffComponent, StaffFormComponent, StaffEditComponent, ClientsComponent, ClientEditComponent, PrinterComissionsComponent, DesignerCommissionsComponent, ViewClientComponent, ClientAddressEditComponent, ClientDiscountPercenatageComponent, StaffComissionPayComponent, ClientAddressListComponent, ClientAddressFormComponent, ArtworkfilesComponent, ManageSubscriptionComponent, UpdateCardComponent, ClientImportComponent],
  entryComponents: [
    ClientAddressEditComponent,
    ClientEditComponent,
    ClientDiscountPercenatageComponent,
    StaffComissionPayComponent,
    ArtworkfilesComponent,
    ClientImportComponent
  ]
})
export class MntUsersModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/mnt-users.module.ts